export enum ContractorTypeEnum {
  Inspector = 'inspector',
  Showami = 'showami',
  Redfin = 'redfin',
  Observa = 'observa',
  TaskRabbit = 'taskrabbit',
  TeamInternal = 'team_internal',
  Surveyor = 'surveyor',
}

export enum OnboardingCompletedStep {
  LandingPageViewed = 'landing_page_viewed',
  FormViewed = 'intake_form_viewed',
  FormSubmitted = 'intake_form_submitted',
  PasswordSet = 'password_set',
}

export type SurveyorLicense = {
  label: string;
  value: string;
  id: string;
}

export const surveyorLicenseOptions: SurveyorLicense[] = [
  { label: 'Inspector', value: 'inspector', id: 'inspectorLicenseHeld' },
  { label: 'Contractor', value: 'contractor', id: 'contractorLicenseHeld' },
  { label: 'Realtor / Real Estate Agent', value: 'realtor', id: 'realEstateLicenseHeld' },
];

export type OnboardingFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  // inspector only
  businessName: string;
  businessSite: string;
  isMultiInspectorFirm: string;
  stateLicenseNumber: string;
  ashiLicenseNumber: string;
  internachiLicenseNumber: string;
  otherLicenseNumber: string;
  // surveyor only
  hasReliableModeOfTransportation: string;
  hasReliablePhone: string;
  sendAutomatedSms: string;
  serviceAreaRadiusMileage: number;
  licenses: string[];
};

export type PasswordFormValues = {
  password: string;
  confirmPassword: string;
}
